export default __webpack_public_path__ + "static/media/add_services01.5f8bed49.webp";